<template>
  <div class="heim-input">
    <label><span class="label">{{label}}</span>
      <input
        class="paper-input"
        :class="inputType=='password'?'password':''"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :step="step"
        :value="inputType == 'date' ? formatedDate(value) : value"
        @input="$emit('input', $event.target.value)"
        :required="required"
      >
    </label>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "heim-input",
  props: {
    label: String,
    placeholder: String,
    type: String,
    name: String,
    step: String,
    required: String,
    value: {
      default: ""
    }
  },
  data: function() {
    return {
      inputType: this.type
    };
  },
  computed: {
    input() {
      return this.$el.querySelector("input");
    }
  },
  methods: {
    formatedDate(date) {
      this.date = format(new Date(date), "YYYY-MM-DD");
      return this.date;
    },
    togglePassword() {
      this.input.type = this.input.type == "password" ? "text" : "password";
      this.inputType = this.input.type;
    }
  }
};
</script>

<style scoped>
.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}
/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .heim-input {
    max-width: 32em;
    margin-bottom: 0.8em;
  }
}
</style>
